// extracted by mini-css-extract-plugin
module.exports = {"price__title":"Price_price__title__1YR5N","price__value":"Price_price__value__1tXxC"};